export default __webpack_public_path__ + "static/media/2.5be3bc7b.svg";